import { render, staticRenderFns } from "./personnel_detail.vue?vue&type=template&id=0c482a06&scoped=true&"
import script from "./personnel_detail.vue?vue&type=script&lang=js&"
export * from "./personnel_detail.vue?vue&type=script&lang=js&"
import style0 from "./personnel_detail.vue?vue&type=style&index=0&id=0c482a06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c482a06",
  null
  
)

export default component.exports